import {  styled } from '@mui/material/styles';
import {  Mixins, Palette, Shadows, Transitions, ZIndex } from '@mui/material';
import { Typography } from '@mui/material/styles/createTypography';
import CircularProgress from '@mui/material/CircularProgress';

interface IStyledProps{
    theme: {
        mixins: Mixins;
        palette: Palette;
        shadows: Shadows;
        transitions: Transitions;
        typography: Typography;
        zIndex: ZIndex;
        unstable_strictMode?: boolean;
      },
}

export const StyledCircular = styled(CircularProgress)(({ theme }: IStyledProps) => {
  return { 
};

});





